import { UserResults, UserSearch } from "../components";

const Home = () => {
  return (
    <>
      <UserSearch />
      <UserResults />
    </>
  );
};
export default Home;
